module.exports = __webpack_public_path__ + "img/4step-image1.d8f54fce.png";